$(document).ready(function(){

    $('.addToCart').on('click', function(e){
        e.preventDefault(),
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data:$('.product-single__form').serialize(),
            dataType: 'json',
            success: function(data) {
                // console.log(data);
              get_cart_details();
              $('body').addClass('cartShown');
            },
            error: function(err){
                console.log('error');
            }
        });
    });

    $('.custom-atc').on('click', function(e){
        e.preventDefault(),
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data:$('.product-single__form').serialize(),
            dataType: 'json',
            success: function(data) {
                // console.log(data);
              get_cart_details();
              $('.product-modal').removeClass('active');
              $('body').addClass('cartShown');
            },
            error: function(err){
                console.log('error');
            }
        });
    });
    // $('.default-btn, .modal-atc').on('click', function(e){
    //     $.ajax({
    //         type: 'POST',
    //         url: '/cart/add.js',
    //         data:$('.product-single__form').serialize(),
    //         dataType: 'json',
    //         success: function(data) {
    //             // console.log(data);
    //             window.location.href='/cart'
    //         },
    //         error: function(err){
    //             console.log('error');
    //         }
    //     });
    // });

    $('img.cart-close, .overly-div').on('click', function(e){
        e.preventDefault();
        $('body').removeClass('cartShown');
    })

    function get_cart_details(){
        $.getJSON('/cart.js', function(cart){
            fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.cart-wrap' , cart_html);
                $('.cart-wrap').replaceWith(cart_items);
            });
        });
    };
    setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
        var cartItems = cart.items;
        // console.log(cartItems.length);
        if( cartItems == 0) {
            $('.cart-item-wrap').html('<div class="empty-cart-content"><h3>YOUR CART IS EMPTY</h3> <div class="empty-cart-btn"><a href="/" class="btn bg-dark-blue">SHOP</a></div></div>');
        }
        });
    }, 10);

});


$(document).on("click",".cart-drawer-open",function(e) {
    e.preventDefault();
    $('body').addClass('cartShown');
});

// increase item
function increaseItem(e, el){
    var myElement = el;
    $input = myElement.previousElementSibling;
    var value = parseInt($input.value);
    if (value < 100){
        value = value + 1;
    }else{
        value = 100;
    }
    $input.value = value;
    changeQty($input);

};
// decrease item
function decreaseItem(e , el){
    $input = el.nextElementSibling;
    var value = parseInt($input.value);
    if (value > 1) {
        value = value - 1;
    } else {
        value = 1;
    }
    $input.value = value;
    changeQty($input);
};

function changeQty($input){
    var variant_id= $($input).data("id");
    var quantity= $($input).val();
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {
            var item = res.items;
            var total_price = res.total_price ;
            var sub_total_price = res.items_subtotal_price;
			var progress;
			var target;
            total_price = total_price/100;
            var total_items = res.item_count;
            $('.total-cost .money').text(currency +((total_price).toFixed(2)));
            $('.cart_count').text(total_items);

            fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.cart-wrap' , cart_html);
                $('.cart-wrap').replaceWith(cart_items);
                // console.log('test' + cart_progress);
            });

        },
        error:function(err){
            console.log('error');
        }
    });
};
// itme remove
function itemRemove(e, el){
    e.preventDefault();
    var id = $(el).data('id');
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
        line: parseFloat(id),
        quantity: 0,
        }
    }).then((data) => {
        $(e.target.parentNode).parent().parent().parent().remove();
        setTimeout(function() {
            $.getJSON('/cart.js', function(cart) {
                var total_price = cart.total_price;
                var total_items = cart.item_count;
                $('.cart_count').text(total_items);
                $('.total-cost .money').text(currency + ((total_price*0.01).toFixed(2)));
                fetch('/?section_id=cart-drawer')
                .then(response => response.text())
                .then(cartData => {
                    var cart_html = $(cartData);
                    var cart_items = $('.cart-wrap' , cart_html);
                    $('.cart-wrap').replaceWith(cart_items);
                    // console.log('test' + cart_progress);
                });
            });
        }, 'fast');
    });
};

